import SpaIcon from "@mui/icons-material/Spa";
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";
import VideogameAssetIcon from "@mui/icons-material/VideogameAsset";
import SailingIcon from "@mui/icons-material/Sailing";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import ForestIcon from "@mui/icons-material/Forest";
import HikingIcon from "@mui/icons-material/Hiking";
import NaturePeopleIcon from "@mui/icons-material/NaturePeople";
import MapIcon from "@mui/icons-material/Map";
import ParaglidingOutlinedIcon from "@mui/icons-material/ParaglidingOutlined";
import RollerSkatingIcon from "@mui/icons-material/RollerSkating";
import DiamondIcon from "@mui/icons-material/Diamond";
import CookieIcon from "@mui/icons-material/Cookie";
import MuseumIcon from "@mui/icons-material/Museum";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import BowlingIcon from "images/icons/BowlingIcon";
import TargetIcon from "images/icons/TargetIcon";

export const theme = {
  color: {
    primary: "#064643",
    secondary: "#4fd1c5",
  },
};

// /!\ When adding a new category, associate it a logo in categoryImageMapping
export const activityCategories: any = {
  ARCADE: "arcade",
  BOWLING: "bowling",
  LASER_GAME: "laserGame",
  PAINTBALL: "paintBall",
  ESCAPE_GAME: "escapeGame",
  SPA: "spa",
  WELL_BEING: "wellBeing",
  VR_SIMULATION: "vrSimulation",
  KARTING: "karting",
  CRUISES: "cruises",
  INDOOR_GAMES: "indoorGames",
  ACCROBRANCHE: "accrobranche",
  HIKING_NATURE: "hikingNature",
  OUTDOOR_GAMES: "outdoorGames",
  GUIDED_TOUR: "guidedTour",
  EXTREM_SPORT: "extremSport",
  BOAT_TRIP: "boatTrip",
  PARACHUTE_JUMP: "parachuteJump",
  CREATIVE_WORKSHOP: "creativeWorkshop",
  COOKING_AND_LESSONS: "cookingAndLessons",
  MUSEUMS_AND_EXHIBITIONS: "museumsAndExhibitions",
  SPORT_AND_FITNESS: "sportAndFitness",
};

export const categoryImageMapping = (category: string, color?: string) => {
  const categoryImageMapping: { [key: string]: any } = {
    ARCADE: <AlternateEmailIcon style={{ color }} />,
    BOWLING: <BowlingIcon color={color} />,
    LASER_GAME: <TargetIcon color={color} />,
    PAINTBALL: <TargetIcon color={color} />,
    ESCAPE_GAME: <ZoomInIcon style={{ color }} />,
    SPA: <SpaIcon style={{ color }} />,
    WELL_BEING: <SelfImprovementIcon style={{ color }} fontSize="small" />,
    VR_SIMULATION: <VideogameAssetIcon style={{ color }} fontSize="small" />,
    KARTING: <DirectionsCarOutlinedIcon style={{ color }} fontSize="small" />,
    CRUISES: <SailingIcon style={{ color }} fontSize="small" />,
    INDOOR_GAMES: <SmartToyIcon style={{ color }} fontSize="small" />,
    ACCROBRANCHE: <ForestIcon style={{ color }} fontSize="small" />,
    HIKING_NATURE: <HikingIcon style={{ color }} fontSize="small" />,
    OUTDOOR_GAMES: <NaturePeopleIcon style={{ color }} fontSize="small" />,
    GUIDED_TOUR: <MapIcon style={{ color }} fontSize="small" />,
    EXTREM_SPORT: <RollerSkatingIcon style={{ color }} fontSize="small" />,
    BOAT_TRIP: <SailingIcon style={{ color }} fontSize="small" />,
    PARACHUTE_JUMP: (
      <ParaglidingOutlinedIcon style={{ color }} fontSize="small" />
    ),
    CREATIVE_WORKSHOP: <DiamondIcon style={{ color }} fontSize="small" />,
    COOKING_AND_LESSONS: <CookieIcon style={{ color }} fontSize="small" />,
    MUSEUMS_AND_EXHIBITIONS: <MuseumIcon style={{ color }} fontSize="small" />,
    SPORT_AND_FITNESS: <FitnessCenterIcon style={{ color }} fontSize="small" />,
  };
  //delete error messages coming from importing component from iconscout/react-unicons package
  // const originalConsoleError = console.error;
  // console.error = (message, ...args) => {
  //   if (
  //     !message.includes(
  //       "Support for defaultProps will be removed from function components",
  //     )
  //   ) {
  //     originalConsoleError(message, ...args);
  //   }
  // };
  return categoryImageMapping[category];
};

export const activitySlotTypes = {
  "30_MINUTES": "30 Minutes",
  "60_MINUTES": "60 Minutes",
  "90_MINUTES": "90 Minutes",
};

// Enums
export enum BookingStatusEnum {
  BOOKED = "BOOKED",
  PENDING = "PENDING",
  CANCELED = "CANCELED",
  NO_SHOW = "NO_SHOW",
  AMENDED = "AMENDED",
  DONE = "DONE",
  DELETED_BY_CLIENT = "DELETED_BY_CLIENT",
  TO_PAY = "TO_PAY",
}

export enum SpecialSlotTypeEnum {
  MARK_AS_FULL = "MARK_AS_FULL",
  UNAVAILABLE = "UNAVAILABLE",
}

export enum PlatformTypeEnum {
  GENERAL = "GENERAL",
  SPECIFIC = "SPECIFIC",
  CSE = "CSE",
  HOPLEISURE = "HOPLEISURE",
  WIDGET = "WIDGET",
}

export enum DiscountTypesEnum {
  PERCENTAGE = "PERCENTAGE",
  SUBSTRACTION = "SUBSTRACTION",
}

export enum ActivityPricesStatusEnum {
  ENABLED = "ENABLED",
  DELETED = "DELETED",
  DISABLED = "DISABLED",
}

export enum ActivityPricesTypeEnum {
  DEFAULT = "DEFAULT",
  SENIOR = "SENIOR",
  CHILD = "CHILD",
  GROUP = "GROUP",
}

export enum ActivityPlatformStatusEnum {
  OPENED = "OPENED",
  PENDING = "PENDING",
  CLOSED = "CLOSED",
}

export enum ActivityCancellationPolicy {
  CANCEL_ANY_TIME = "CANCEL_ANY_TIME",
  CANCEL_24_HOURS = "CANCEL_24_HOURS",
  CANCEL_48_HOURS = "CANCEL_48_HOURS",
  CANCEL_72_HOURS = "CANCEL_72_HOURS",
  CANCEL_30_DAYS = "CANCEL_30_DAYS",
}

export enum ActivityTypeEnum {
  INDIVIDUAL = "INDIVIDUAL",
  GROUP = "GROUP",
}

export enum ActivityTypeHours {
  HOURS_OPERATIONS = "HOURS_OPERATIONS",
  TIME_SLOTS = "TIME_SLOTS",
}

export enum SlotPunctual {
  ADD = "ADD",
  DELETE = "DELETE",
  EDIT = "EDIT",
  OVERLAPPING_SLOTS_CREATION = "OVERLAPPING_SLOTS_CREATION",
}

export enum ActivitySlotStatus {
  REPLACE = "REPLACE",
  CANCEL = "CANCEL",
  MAINTAIN = "MAINTAIN",
}

export const activityScheduleTypes = {
  [ActivityTypeHours.HOURS_OPERATIONS]: "openingHours",
  [ActivityTypeHours.TIME_SLOTS]: "timeSlots",
};

export enum LanguageEnum {
  ENGLISH = "English",
  FRENCH = "French",
  SPANISH = "Spanish",
}

export enum TranslationLanguageEnum {
  FR = "fr",
  EN = "en",
}

export const emptyActivity: any = {
  informations: {
    description: "",
    slotDuration: 0,
    images: [],
    email: "",
    name: "",
    address: "",
    timezone: {},
    website: "",
    phone: "",
    cancelation: "",
    category: "ARCADE",
    isEnabled: false,
    bookingSettings: {
      type: "",
    },
  },
  hours: {
    hours: {
      "0": {
        slots: [],
      },
      "1": {
        slots: [],
      },
      "2": {
        slots: [],
      },
      "3": {
        slots: [],
      },
      "4": {
        slots: [],
      },
      "5": {
        slots: [],
      },
      "6": {
        slots: [],
      },
    },
    slotPunctual: [],
  },
  prices: [],
  channels: [],
};

export const listOfPositiveNumber = (number: number) =>
  Array.from(Array(number).keys());

export enum DATEFORMAT {
  MONTH = "YYYY-MM",
  DAY = "YYYY-MM-DD",
  DATE_TIME = "YYYY-MM-DD HH:mm",
  MONTH_YEAR = "MMMM, YYYY",
  TIME = "HH:mm",
}

export enum SectionProfileEnum {
  General = "general",
  Invoicing = "invoicing",
}

export enum RoleEnum {
  Administrateur = "Administrateur",
  Membre = "Membre",
  Invité = "Invité",
}

export enum UserStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DELETED = "DELETED",
}

export enum EmailTemplateTypeEnum {
  REMINDER = "Rappel préalable à l’expérience",
  REVIEW_REQUEST = "Demande d’avis postérieure à l’expérience",
  CONFIRMATION = "Confirmation de réservation",
  CANCELLATION = "Annulation de réservation",
  LOYALTY = "Fidélité - Base client",
}

export enum SectionEmailingEnum {
  Emailing = "emailing",
  Assign = "assign",
}

export enum VisitorEmailPolicy {
  None = "none",
  InternalOnly = "internal_only",
  InternalAndExternal = "internal_and_external",
}

export enum EmailTemplateEventEnum {
  BOOKING_CONFIRMATION = "booking_confirmation",
  BOOKING_CANCELLATION = "booking_cancellation",
  BOOKING_REMINDER = "booking_reminder",
  POST_BOOKING_FEEDBACK = "post_booking_feedback",
}

export const ApiErrors = {
  HOURS_WITH_FROM_BIGGER_THAN_TO: "HOURS_WITH_FROM_BIGGER_THAN_TO",
};

export const CURRENCY = "€";
